import URI from 'urijs';
import {throwError} from "rxjs";
import {ajaxAuthed, API_BASE, RESULT_LIMIT} from "./common";
import {APIError} from "../common/errors";

function getProjectDocumentRequest(subroute) {
  return ({ id, projectId, offset }) => {
    if (!projectId) return throwError(new APIError(`no project id specified for project ${subroute}`));
    let url;
    if (id) {
      url = URI.joinPaths(API_BASE, 'projects', projectId, subroute, id);
    } else {
      let query = {
        limit: RESULT_LIMIT,
        offset,
      };
      url = URI.joinPaths(API_BASE, 'projects', projectId, subroute);
      url.query(URI.buildQuery(query));
    }
    return ajaxAuthed({url: url.toString() });
  };
}

function getProjectDocumentRequestMulti(subroute) {
  return ({ projectId, ids }) => {
    if (!ids) throw new APIError('getProjectsMulti$: no id specified in API call');
    let url = URI.joinPaths(API_BASE, 'projects', projectId, subroute);
    url.query(URI.buildQuery({ id: ids }, true));
    return ajaxAuthed({ url: url.toString() });
  }
}

function createProjectDocumentRequest(subroute) {
  return ({ projectId, document }) => {
    if (!projectId) return throwError(new APIError(`no project id specified for project ${subroute}`));
    let url = URI.joinPaths(API_BASE, 'projects', projectId, subroute);
    return ajaxAuthed({url: url.toString(), method: 'POST', body: document, headers: { 'Content-Type': 'application/json'} });
  };
}

function updateProjectDocumentRequest(subroute) {
  return ({ projectId, subId, document }) => {
    if (!projectId) return throwError(new APIError(`no project id specified for project ${subroute}`));
    if (!subId) return throwError(new APIError(`no document id specified for project ${subroute}`));
    let url = URI.joinPaths(API_BASE, 'projects', projectId, subroute, subId);
    return ajaxAuthed({url: url.toString(), method: 'PUT', body: document, headers: { 'Content-Type': 'application/json'} });
  };
}

function deleteProjectDocumentRequest(subroute) {
  return ({ projectId, subId }) => {
    if (!projectId) return throwError(new APIError(`no project id specified for project ${subroute}`));
    let url = URI.joinPaths(API_BASE, 'projects', projectId, subroute, subId);
    return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
  }
}

export function getProjects$({ id, offset, sortby, sortoffset, order, filterby, from, to, status, limit, search }) {
  let url;
  if (id) {
    url = URI.joinPaths(API_BASE, 'projects', id);
  } else {
    url = URI.joinPaths(API_BASE, 'projects');
    url.query(URI.buildQuery({ limit: Math.min(limit, RESULT_LIMIT) || RESULT_LIMIT, offset, sortby, sortoffset, sortorder: order, filterby, filterstart: from, filterend: to, status, q: search }));
  }
  return ajaxAuthed({ url: url.toString() });
}

export function getProjectsIndex$({ id, offset, sortby, sortoffset, order, filterby, from, to, status, limit, search }) {
  let url;
  url = URI.joinPaths(API_BASE, 'projects');
  url.query(URI.buildQuery({ limit: Math.min(limit, RESULT_LIMIT) || RESULT_LIMIT, offset, sortby, sortoffset, sortorder: order, filterby, filterstart: from, filterend: to, status, index: '', q: search }));
  return ajaxAuthed({ url: url.toString() });
}

export function getProjectsMulti$({ ids }) {
  if (!ids) throw new APIError('getProjectsMulti$: no id specified in API call');
  let url = URI.joinPaths(API_BASE, 'projects');
  url.query(URI.buildQuery({ id: ids }, true));
  return ajaxAuthed({ url: url.toString() });
}

export function createProject$({ project }) {
  if (!project) throw new APIError('no project record specified for createProject');
  let url = URI.joinPaths(API_BASE, 'projects');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: project, headers: { 'Content-Type': 'application/json'} });
}

export function updateProject$({ projectId, project }) {
  if (!projectId) throw new APIError('no project id specified for updateProject');
  if (!project) throw new APIError('no project record specified for updateProject');
  let url = URI.joinPaths(API_BASE, 'projects', projectId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: project, headers: { 'Content-Type': 'application/json'} });
}

export function deleteProject$({ projectId }) {
  if (!projectId) throw new APIError('no project id specified for deleteProject');
  let url = URI.joinPaths(API_BASE, 'projects', projectId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

const MEETING_MINUTES = 'meeting-minutes';
export const getMeetingMinutes$ = getProjectDocumentRequest(MEETING_MINUTES);
export const getMeetingMinutesMulti$ = getProjectDocumentRequestMulti(MEETING_MINUTES);
export const createMeetingMinutes$ = createProjectDocumentRequest(MEETING_MINUTES);
export const deleteMeetingMinutes$ = deleteProjectDocumentRequest(MEETING_MINUTES);
export const updateMeetingMinutes$ = updateProjectDocumentRequest(MEETING_MINUTES);

const DAILY_LOGS = 'daily-logs';
export const getDailyLogs$ = getProjectDocumentRequest(DAILY_LOGS);
export const getDailyLogsMulti$ = getProjectDocumentRequestMulti(DAILY_LOGS);
export const createDailyLog$ = createProjectDocumentRequest(DAILY_LOGS);
export const deleteDailyLog$ = deleteProjectDocumentRequest(DAILY_LOGS);
export const updateDailyLog$ = updateProjectDocumentRequest(DAILY_LOGS);

const RFIS = 'project-rfis';
export const getProjectRfis$ = getProjectDocumentRequest(RFIS);
export const getProjectRfisMulti$ = getProjectDocumentRequestMulti(RFIS);
export const createProjectRfi$ = createProjectDocumentRequest(RFIS);
export const deleteProjectRfi$ = deleteProjectDocumentRequest(RFIS);
export const updateProjectRfi$ = updateProjectDocumentRequest(RFIS);

const SUBMITTALS = 'submittals';
export const getSubmittals$ = getProjectDocumentRequest(SUBMITTALS);
export const getSubmittalsMulti$ = getProjectDocumentRequestMulti(SUBMITTALS);
export const createSubmittal$ = createProjectDocumentRequest(SUBMITTALS);
export const deleteSubmittal$ = deleteProjectDocumentRequest(SUBMITTALS);
export const updateSubmittal$ = updateProjectDocumentRequest(SUBMITTALS);

const TASKS = 'tasks';
export const getTasks$ = getProjectDocumentRequest(TASKS);
export const getTasksMulti$ = getProjectDocumentRequestMulti(TASKS);
export const createTask$ = createProjectDocumentRequest(TASKS);
export const deleteTask$ = deleteProjectDocumentRequest(TASKS);
export const updateTask$ = updateProjectDocumentRequest(TASKS);

const PUNCHES = 'punches';
export const getPunches$ = getProjectDocumentRequest(PUNCHES);
export const getPunchesMulti$ = getProjectDocumentRequestMulti(PUNCHES);
export const createPunch$ = createProjectDocumentRequest(PUNCHES);
export const deletePunch$ = deleteProjectDocumentRequest(PUNCHES);
export const updatePunch$ = updateProjectDocumentRequest(PUNCHES);

export function setProjectViewed$({ projectId }) {
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'seen');
  return ajaxAuthed({ url: url.toString(), method: 'POST' });
}

export function getProjectInvites$({ projectId, id, offset, q }) {
  if (!projectId) throw new APIError('no project id specified for getProjectInvites');
  let query = {
    limit: RESULT_LIMIT,
    id,
    offset,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function createProjectInvites$({ projectId, inviteUserIds = [] }) {
  if (!projectId) throw new APIError('no project id specified for createProjectInvites');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: inviteUserIds, headers: { 'Content-Type': 'application/json'} });
}

export function leaveProject$({ projectId }) {
  if (!projectId) throw new APIError('no project id specified for leaveProject');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites');
  return ajaxAuthed({ url: url.toString(), method: 'DELETE'});
}

export function createEmailProjectInvites$({ projectId, inviteUserEmails = [] }) {
  if (!projectId) throw new APIError('no project id specified for createEmailProjectInvites');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites', 'emails');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: inviteUserEmails, headers: { 'Content-Type': 'application/json'} });
}

export function createProjectContactListInvites$({ projectId, contactListIds = [] }) {
  if (!projectId) throw new APIError('no project id specified for createProjectContactListInvites');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites', 'contact-lists');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: contactListIds, headers: { 'Content-Type': 'application/json'} });
}

export function getProjectInviteById$({ projectId, userId }) {
  if (!projectId) throw new APIError('no project id specified for getProjectInviteById');
  if (!userId) throw new APIError('no user id specified for getProjectInviteById');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites', userId);
  return ajaxAuthed({ url: url.toString() });
}

export function updateProjectInvitePermissions$({ projectId, userId, role }) {
  if (!projectId) throw new APIError('no project id specified for updateProjectInvitePermissions');
  if (!userId) throw new APIError('no user id specified for updateProjectInvitePermissions');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites', userId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: { role }, headers: { 'Content-Type': 'application/json'} });
}

export function deleteProjectInvite$({ projectId, userId }) {
  if (!projectId) throw new APIError('no project id specified for deleteProjectInvite');
  if (!userId) throw new APIError('no user id specified for deleteProjectInvite');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'invites', userId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE'});
}

export function getProjectPhoto$({ projectId }) {
  if (!projectId) throw new APIError('no project id specified for getProjectPhoto');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'photos');
  return ajaxAuthed({ url: url.toString() });
}

export function deleteProjectPhoto$({ projectId }) {
  if (!projectId) throw new APIError('no project id specified for deleteProjectPhoto');
  let url = URI.joinPaths(API_BASE, 'projects', projectId, 'photos');
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}



// WEBPACK FOOTER //
// ./src/services/projects.js